// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignOutRouteImport } from './routes/sign-out'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppDashboardRouteImport } from './routes/_app.dashboard'
import { Route as AppDashboardProfileRouteImport } from './routes/_app.dashboard_.profile'
import { Route as AppDashboardNewsRouteImport } from './routes/_app.dashboard_.news'
import { Route as AppDashboardDestinationsRouteImport } from './routes/_app.dashboard_.destinations'
import { Route as AppDashboardContactsRouteImport } from './routes/_app.dashboard_.contacts'
import { Route as AppDashboardApiKeysRouteImport } from './routes/_app.dashboard_.api-keys'
import { Route as AppDashboardActivitiesRouteImport } from './routes/_app.dashboard_.activities'

const SignOutRoute = SignOutRouteImport.update({
            id: '/sign-out',path: '/sign-out',getParentRoute: () => rootRouteImport
          })
const SignInRoute = SignInRouteImport.update({
            id: '/sign-in',path: '/sign-in',getParentRoute: () => rootRouteImport
          })
const AppRoute = AppRouteImport.update({
            id: '/_app',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AppDashboardRoute = AppDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AppRoute
          })
const AppDashboardProfileRoute = AppDashboardProfileRouteImport.update({
            id: '/dashboard_/profile',path: '/dashboard/profile',getParentRoute: () => AppRoute
          })
const AppDashboardNewsRoute = AppDashboardNewsRouteImport.update({
            id: '/dashboard_/news',path: '/dashboard/news',getParentRoute: () => AppRoute
          })
const AppDashboardDestinationsRoute = AppDashboardDestinationsRouteImport.update({
            id: '/dashboard_/destinations',path: '/dashboard/destinations',getParentRoute: () => AppRoute
          })
const AppDashboardContactsRoute = AppDashboardContactsRouteImport.update({
            id: '/dashboard_/contacts',path: '/dashboard/contacts',getParentRoute: () => AppRoute
          })
const AppDashboardApiKeysRoute = AppDashboardApiKeysRouteImport.update({
            id: '/dashboard_/api-keys',path: '/dashboard/api-keys',getParentRoute: () => AppRoute
          })
const AppDashboardActivitiesRoute = AppDashboardActivitiesRouteImport.update({
            id: '/dashboard_/activities',path: '/dashboard/activities',getParentRoute: () => AppRoute
          })





const AppRouteChildren = {
  AppDashboardRoute: AppDashboardRoute,AppDashboardActivitiesRoute: AppDashboardActivitiesRoute,AppDashboardApiKeysRoute: AppDashboardApiKeysRoute,AppDashboardContactsRoute: AppDashboardContactsRoute,AppDashboardDestinationsRoute: AppDashboardDestinationsRoute,AppDashboardNewsRoute: AppDashboardNewsRoute,AppDashboardProfileRoute: AppDashboardProfileRoute
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AppRoute: AppRouteWithChildren,SignInRoute: SignInRoute,SignOutRoute: SignOutRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)